module.exports = __webpack_public_path__ + "static/media/BigJohnPRO-Bold.0894f6c0.woff";